import getOffsetTop from '../utils/get-offset-top';
import isIos from '../utils/detect-ios';

export default () => {
  const el = document.querySelector('.hero-header');

  if (el) {
    const adjustMaxHeight = () => {
      const top = getOffsetTop(el);
      const iosViewport = document.querySelector('.ios-viewport-check');

      if (iosViewport) {
        const viewportHeight = iosViewport.clientHeight;
        const maxHeight = viewportHeight - top;
        el.style.maxHeight = `${maxHeight}px`;
        el.style.height = `${maxHeight}px`;
      } else {
        el.style.maxHeight = `calc(100vh - ${top}px)`;
        el.style.height = `calc(100vh - ${top}px)`;
      }
    };
    window.addEventListener('load', adjustMaxHeight);
    window.addEventListener('resize', adjustMaxHeight);
  }
};
